import React from 'react'
import { logError, logSuccess } from '../../../toaster'
import { useIntl } from 'react-intl'
import { ExcludeActionSharedProps, SharedExcludeAction } from './shared'
import { useBulkExcludeRoutesMutation } from '../../exclude-dialog/use-bulk-exclude-routes'

interface Props extends ExcludeActionSharedProps {
  readonly routeHashes: string[]
  readonly pendoId: string
  readonly agentSessionId?: string[]
}

export function ExcludeByRouteHashesAction({
  onSuccess,
  applicationRole,
  organizationUuid,
  applicationUuid,
  routeHashes,
  pendoId,
  ...rest
}: Props) {
  const intl = useIntl()
  const number = routeHashes.length === 1 ? 'single' : 'multiple'

  const bulkExcludeRoutesMutation = useBulkExcludeRoutesMutation({
    onSuccess: () => {
      logSuccess(
        intl.formatMessage(
          {
            id: 'plural_applicationCoverage_successfullyExcludedRoute'
          },
          {
            number
          }
        )
      )
      onSuccess()
    },
    onError: () =>
      logError(
        intl.formatMessage(
          {
            id: 'plural_applicationCoverage_errorExcludingRoute'
          },
          {
            number
          }
        )
      )
  })

  const excludeOperation = () => {
    bulkExcludeRoutesMutation.mutate({
      organizationUuid,
      applicationUuid,
      routeHashes
    })
  }

  return (
    <SharedExcludeAction
      {...rest}
      applicationRole={applicationRole}
      organizationUuid={organizationUuid}
      applicationUuid={applicationUuid}
      onSuccess={excludeOperation}
      number={number}
      pendoId={pendoId}
    />
  )
}
